import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import Insurance from "../../components/InsuranceCharges/Insurance";


const InsuranceChargesPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
             
                <Breadcrumb title="Insurance Charges" />
                <Insurance/>



            </MasterLayout>
        </>
    );
};

export default InsuranceChargesPage;
